//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from 'lodash';
import DpControlGroup from '../layout/ControlGroup.vue';

export const units = {
  h: 'whole hour',
  d: 'whole day',
  w: 'whole week',
  M: 'whole month',
};

export const partialUnits = {
  h: 'This hour',
  d: 'Today',
  w: 'This week',
  M: 'This month',
};

export default {
  name: 'DpRollingTime',
  components: {
    DpControlGroup,
  },
  props: {
    value: { type: Object, default: null },
  },
  data() {
    return {
      current: {
        value: null,
        unit: 'd',
      },
      units: [
        // { value: 'h', label: 'Hour' },
        { value: 'd', label: 'whole day' },
        { value: 'w', label: 'whole week' },
        { value: 'M', label: 'whole month' },
      ],
    };
  },
  computed: {
    preview() {
      const { value, unit } = this.current;
      if (value === null) {
        return '';
      }

      return this.getPreview(value, unit);
    },
    range() {
      const { value, unit } = this.current;
      const range = {};

      if (value === null) return null;
      if (value === 0) {
        return null;
      }

      if (value !== null) {
        // 0/d -> 1/d && inclusive as the UI is now additive
        const apiDays = value + 1;
        range.period = `${apiDays}${unit}`;
      }

      return range;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue) return;
        this.current = { ...newValue };
      },
    },
  },
  methods: {
    getPreview(value, unit) {
      if (value === 0) return null;
      if (value === 1) {
        switch (unit) {
          case 'h': return 'Previous full hour';
          case 'd': return 'Yesterday';
          case 'w': return 'Previous week';
          case 'M': return 'Previous month';
          default: return '';
        }
      }

      return `Previous ${value} ${units[unit]}s`;
    },
    clear() {
      this.current.value = null;
    },
    pushChanges: debounce(function pushChanges() {
      const { range } = this;
      if (!range) {
        this.$emit('change', null);
      }

      this.$emit('change', {
        value: this.current,
        description: this.preview,
        range,
      });
    }, 500),
  },
};
